module.exports = __webpack_public_path__ + "img/sad-smile.99070a64.svg";